import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModal, showModalTop } from '../../actions';

import {
  userCan,
  userHasCap,
} from '../../helpers/Auth';

const DashboardWidgetCreateCollection = ({
  afterCreateCollection,
  openCollectionEditModal,
  openCollectionCreatedModal,
}) => {
  const intl = useIntl();

  const handleAfterCreateCollection = (data) => {
    openCollectionCreatedModal({
      collectionUuid: data.uuid,
    });
    afterCreateCollection();
  };

  if (!(userCan('collection.create') || userHasCap('create_collection_all'))) {
    return null;
  }

  return (
    <div className="widget widget-create-collection collections-item">
      <div>
        <div className="collections-item-img-wrapper">
          <div className="collections-item-img">
            <i className="fal fa-plus" />
          </div>
        </div>
        <div className="collections-item-body">
          <h5>{intl.formatMessage({ defaultMessage: 'Create a new Collection' })}</h5>
          <div className="collections-item-details file-details" />
          <div className="collection-actions">
            <Button
              color="link"
              onClick={() => {
                openCollectionEditModal({
                  className: 'modal-new-collection',
                  afterCreateCollection: handleAfterCreateCollection,
                });
              }}
            >
              <i className="far fa-plus" />
              {intl.formatMessage({ defaultMessage: 'Create' })}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  openCollectionEditModal: (params) => {
    dispatch(showModal('CollectionEditModal', params));
  },
  openCollectionCreatedModal: (params) => {
    dispatch(showModalTop('CollectionCreatedModal', params));
  },
});

DashboardWidgetCreateCollection.propTypes = {
  openCollectionEditModal: PropTypes.func.isRequired,
  openCollectionCreatedModal: PropTypes.func.isRequired,
  afterCreateCollection: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(DashboardWidgetCreateCollection);
